import { Slider } from "../components/Slider";
import { useDispatch, useSelector } from "react-redux";

export const ParameterSlider = ({ parameterHandler, orientation, className, size, style={}, label, labelSize="12px", noLabel=false, noOutput=false, ...props }) => {

    if (orientation==='vertical') style.height = size ?? style.height ?? '80px';
    if (orientation==='horizontal') style.width = size ?? style.width ?? '200px';

    const dispatch = useDispatch();
    const onNewValue = value => dispatch(parameterHandler.updater(parameterHandler.num2Real(value)));

    const realValue = useSelector(parameterHandler.selector);
    return (
        <Slider
            {...props}
            style={style}
            className={className}
            orientation={orientation}
            value={parameterHandler.real2Num(realValue)}
            step={parameterHandler.getStep()}
            min={parameterHandler.getNumericMin()}
            max={parameterHandler.getNumericMax()}
            onNewValue={onNewValue}
            label={label || parameterHandler.description.label}
            output={parameterHandler.real2String(realValue)}
            noLabel={noLabel} noOutput={noOutput}
            onDoubleClick={() => dispatch(parameterHandler.updater(parameterHandler.getDefaultValue()))}
        />
    )
};